import { createFileRoute, redirect } from "@tanstack/react-router";

import { appInstanceApi } from "@workspace/app-instance/api";
import { PageLoading } from "@workspace/venue-management";

import { firstLocationId } from "@/lib/first-location";
import { NoLocations } from "@/components/no-locations";

export const Route = createFileRoute("/_auth/_dashboard/$tenant/")({
	pendingComponent: PageLoading,
	beforeLoad: async ({ context, params, location }) => {
		if (!context.auth.isAuthenticated) {
			throw redirect({
				to: "/login",
				search: {
					redirect: location.href,
				},
			});
		} else {
			// HA-746: await the app instance, as venue-management's $tenant.index does. The router
			// context's tenants.root is a snapshot that can predate the query resolving.
			const app = await context.queryClient
				.ensureQueryData(appInstanceApi.getOptionsCurrent(params.tenant))
				.then((d) => d.item)
				.catch(() => null);

			if (!app) {
				return { noLocations: false };
			}

			// HA-753: a tenant with no locations has no terminal to open.
			const venueId = firstLocationId(app);
			if (!venueId) {
				return { noLocations: true };
			}

			throw redirect({
				to: "/$tenant/venues/$venueId",
				params: {
					tenant: app.id,
					venueId,
				},
			});
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { noLocations } = Route.useRouteContext();

	return noLocations ? <NoLocations /> : null;
}
